import { gql } from '@apollo/client'

export const GET_ADDITIONAL_COMPONENT_GROUPS = gql`
  query GET_ADDITIONAL_COMPONENT_GROUPS(
    $searchTerm: String
    $language: Language
    $take: Int
    $skip: Int
    $orderBy: [AdditionalComponentGroupOrderByWithRelationInput!]
    $filters: [AdditionalComponentGroupWhereInput]
  ) {
    findManyAdditionalComponentGroupCount(
      where: {
        OR: [
          {
            additional_component_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: { equals: $language }
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
    )

    findManyAdditionalComponentGroup(
      orderBy: $orderBy
      where: {
        OR: [
          {
            additional_component_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: { equals: $language }
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      id
      code
      createdAt
      use_fabric_prices_for_components
      enable_custom_dimensions_for_components
      enabled_dimensions_in_group
      additional_component_group_profiles(
        where: { language: { equals: $language } }
      ) {
        id
        name
        description
        language
      }
      _count {
        additional_components
      }
    }
  }
`

// Guarded backend delete (types-modified/AdditionalComponentDelete.ts): deletes
// the group's components, product links and prices in one transaction, and
// refuses when an order/offer line references one of its components. The
// generated deleteOne/deleteMany are denyAll.
export const DELETE_ADDITIONAL_COMPONENT_GROUP = gql`
  mutation DELETE_ADDITIONAL_COMPONENT_GROUP($id: Int!) {
    deleteSingleAdditionalComponentGroup(id: $id) {
      id
      code
      deletedComponents
      removedGroupProductLinks
      removedComponentProductLinks
      detachedCartItems
    }
  }
`

export const GET_ADDITIONAL_COMPONENT_GROUP_USAGE = gql`
  query GET_ADDITIONAL_COMPONENT_GROUP_USAGE($id: Int!) {
    additionalComponentGroupUsage(id: $id) {
      id
      code
      productCount
      componentCount
      orderLineCount
      offerLineCount
      cartLineCount
      blocked
    }
  }
`

export const CORE_ADDITIONAL_COMPONENT_GROUP_DATA = gql`
  fragment CoreAdditionalComponentGroupData on AdditionalComponentGroup {
    id
    code
    createdAt
    use_fabric_prices_for_components
    enable_custom_dimensions_for_components
    enabled_dimensions_in_group
    additional_component_group_profiles {
      id
      name
      description
      language
    }
    _count {
      additional_components
    }
  }
`

export const UPDATE_ADDITIONAL_COMPONENT_GROUP = gql`
  mutation UPDATE_ADDITIONAL_COMPONENT_GROUP(
    $where: AdditionalComponentGroupWhereUniqueInput!
    $additional_component_group_profiles: [AdditionalComponentGroupProfileCustomInput!]
    $code: String
    $use_fabric_prices_for_components: Boolean
    $enable_custom_dimensions_for_components: Boolean
    $enabled_dimensions_in_group: [String!]
    $ui_type: String
    $hide_components_without_price: Boolean
  ) {
    updateSingleAdditionalComponentGroup(
      where: $where
      additional_component_group_profiles: $additional_component_group_profiles
      code: $code
      use_fabric_prices_for_components: $use_fabric_prices_for_components
      enable_custom_dimensions_for_components: $enable_custom_dimensions_for_components
      enabled_dimensions_in_group: $enabled_dimensions_in_group
      hide_components_without_price: $hide_components_without_price
      ui_type: $ui_type
    ) {
      id
    }
  }
`

export const CREATE_ADDITIONAL_COMPONENT_GROUP = gql`
  mutation CREATE_ADDITIONAL_COMPONENT_GROUP(
    $manufacturerId: Int!
    $additional_component_group_profiles: [AdditionalComponentGroupProfileCustomInput!]
    $code: String
    $use_fabric_prices_for_components: Boolean
    $enable_custom_dimensions_for_components: Boolean
    $enabled_dimensions_in_group: [String!]
    $ui_type: String
    $order: Int
  ) {
    createSingleAdditionalComponentGroup(
      manufacturerId: $manufacturerId
      additional_component_group_profiles: $additional_component_group_profiles
      code: $code
      use_fabric_prices_for_components: $use_fabric_prices_for_components
      enable_custom_dimensions_for_components: $enable_custom_dimensions_for_components
      enabled_dimensions_in_group: $enabled_dimensions_in_group
      ui_type: $ui_type
      order: $order
    ) {
      id
    }
  }
`

export const GET_ADDITIONAL_COMPONENT_GROUP = gql`
  query GET_ADDITIONAL_COMPONENT_GROUP($id: Int!) {
    findUniqueAdditionalComponentGroup(where: { id: $id }) {
      id
      manufacturerId
      code
      use_fabric_prices_for_components
      enable_custom_dimensions_for_components
      hide_components_without_price
      enabled_dimensions_in_group
      additional_component_group_profiles {
        id
        name
        description
        language
      }
      _count {
        additional_components
      }
      ui_type
      order
    }
  }
`
